export const userInfoUpdateOperations = Object.freeze({
  ACCOUNT_TYPE: "ACCOUNT_TYPE"
});
